import React, { useRef, useEffect, useState, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Download as DownloadIcon,
    Upload as UploadIcon,
    Search,
    Menu as SquareMenu,
    Delete,
    Add as CirclePlus,
    History as BookUp,
    Remove as CircleDivide,
    ContentCopy as CopyIcon,
    Refresh as RefreshIcon,
    CloudUpload as CloudUploadIcon
} from "@mui/icons-material";
import { styled } from '@mui/material/styles'
import Popup from "../../components/SimplePOPUP";
import dayjs from "dayjs";
import {
    Tooltip,
    TextField,
    Select,
    MenuItem,
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box,
    Stack,
    Grid,
    FormControl,
    InputLabel,
    Divider,
    CircularProgress,
    Autocomplete
} from "@mui/material";
import { ExpandMore as ChevronDown } from "@mui/icons-material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import {
    useDynamicOption,
    useChangeValByserviceID,
    useSearchDynamicOptions,
    useTableRowAdd,
    usePopupSelectFn,
    useOnChangeOperation,
    useTableDelRow,
    useTableCopyRow,
    useRefreshDependencies,
    useCreateTransaction
} from "../../hooks/dynamicform.hooks";
import {
    rerender as rerenderAction,
    setChangesLog,
    setDialogData,
    setDOCJSON,
    setStoreVals,
    updateValidationErrorByKey,
    clearValidationError,
    setValidationError,
    updateDynamicOptionDone,
    updateValidationError
} from "../../redux/DynamicForms/dynamicFormsActions";
import { DraggableDialog } from "../../components/DragableDialogBox/DragableDialogBox";
import { DialogBox } from "../../components/DialogBox/DialogBox";
import TableWithFilter from "../../components/TableWithFilter/TableWithFilter";
import { generateUniqueNumber, Get_Val_By_ServiceKey, removeSpecialCharacters, removeSpecialCharacters_exceptDOT, trim } from "../../globalhelper/DynamicFormHelpers";
import { getVendorActivityCode, postRequest } from "../../globalhelper/helper";
import moment from "moment";

export default function DynamicTable({
    screenName,
    tableData,
    rerender,
    DocumentStatus,
    showDrawer,
    isBodySection,
    onOpenChange
}) {
    const dispatch = useDispatch();
    const fileInputRef = useRef(null);

    // Hooks
    const fetchDynamicOptions = useDynamicOption();
    const tableRowAdd = useTableRowAdd();
    const tableDelRow = useTableDelRow();
    const tableCopyRow = useTableCopyRow();
    const changeValByserviceID = useChangeValByserviceID();
    const dynamicOptionSearch = useSearchDynamicOptions();
    const popupSelectFn = usePopupSelectFn();
    const onChange_operation = useOnChangeOperation();
    const refreshDependencies = useRefreshDependencies();
    const createTransaction = useCreateTransaction();
    const dynamicOptionDone = useSelector(state => state.dynamicForms.dynamicOption_Done || {});
    const [allActivityCodes, setAllActivityCodes] = useState([]);
    // Redux Selectors (Legacy State)
    const DOCJSON = useSelector(state => state.dynamicForms.DOCJSON || []);
    const oneSidePDFKey = useSelector(state => state.dynamicForms.oneSidePDFKey || "");
    const userData = useSelector(state => state.login.userData || {});
    const logs = useSelector(state => state.dynamicForms.changesLog || {});
    const vals = useSelector(state => state.dynamicForms.storeVals || {});
    const dialogData = useSelector(state => state.dynamicForms.DialogData || {});
    const athenaStorage = useSelector(state => state.dynamicForms.athenaStorage || {});
    const ValidationError = useSelector(state => state.dynamicForms.validationError || {});
    const dynamicOption_Done = useSelector(state => state.dynamicForms.dynamicOption_Done || {});

    const [file, setFile] = useState({});
    const [openPopupSelect, setOpenPopupSelect] = useState(false);
    const [askReason, setAskReason] = useState(null);
    const [apiExecution, setApiExecution] = useState({});
    const [state, setState] = useState({
        open_popup: false,
        popup_table: {
            search: "",
            data: [],
            filteredData: [],
            header: []
        },
        showPopUP_PDF: false,
        popData_PDF: false,
        fileType: ''
    });

    const base64ToBlob = (base64, mimeType) => {
        const byteArray = Uint8Array.from(atob(base64), (char) =>
            char.charCodeAt(0),
        );
        return new Blob([byteArray], { type: mimeType });
    };

    const date_DD_MM_YYYY_TO_YYYY_MM_DD = (dateObj) => {
        if (!dateObj) return "";
        // If it's a dayjs/moment object (has a format method)
        if (typeof dateObj.format === "function") {
            console.log(dateObj.format, dateObj);

            return dayjs(dateObj, ["DD-MM-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
        }
        // If it's a string, try parsing it
        if (typeof dateObj === "string") {
            let parsed = dayjs(dateObj, ["DD-MM-YYYY", "YYYY-MM-DD"]);
            return parsed.isValid() ? parsed.format("YYYY-MM-DD") : dateObj;
        }

        return dayjs(dateObj, ["DD-MM-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
    };

    const ifNotReject = useCallback((childrenNode, children_Node) => {
        let reason = children_Node?.find((each) => each.serviceKey === "Reason");
        if (reason && reason.val) {
            changeValByserviceID(reason.serviceID, 'serviceID', 'val', "");
        }
    }, [changeValByserviceID]);

    const ifReject = useCallback((childrenNode, children_Node) => {
        let reason = children_Node?.find((each) => each.serviceKey === "Reason");
        if (reason) {
            setAskReason({ ...reason, targetCell: childrenNode });
        }
    }, []);

    const openPDF = (e, childrenNode) => {
        e?.preventDefault();
        postRequest(`api/vr2/getPDF_file`, {
            key: childrenNode?.val,
        }).then((res) => {
            if (res.res.status === "success") {
                setState((prev) => ({
                    ...prev,
                    showPopUP_PDF: childrenNode.serviceID,
                    popData_PDF: res.res.data,
                    fileType: childrenNode?.val.split(".").at(-1),
                }));
            }
        });
    };


    const onUpload = async (e, childrenNode) => {
        let serviceKey = e.target.name;
        let serviceID = e.target.id;

        let DateTime = dayjs(new Date()).format("DD-MM-YYYY HH:mm:ss");

        let updatedLogs = { ...logs };
        let updatedVals = { ...vals };

        const files = Array.from(e.target.files);
        const totalSize = files.reduce((acc, file) => acc + file.size, 0);

        const MAX_TOTAL_SIZE = 50 * 1024 * 1024; // 50MB

        let file = e.target.files[0];
        if (
            file &&
            e.target.files &&
            e.target.files?.length &&
            files.every((file) => file.name.toLowerCase().includes("pdf")) &&
            Number(MAX_TOTAL_SIZE) > totalSize
        ) {
            let fileName =
                generateUniqueNumber() +
                removeSpecialCharacters_exceptDOT(file.name);

            const Module = localStorage.getItem("module");
            const screenNameClean = removeSpecialCharacters(screenName);
            const fieldName = removeSpecialCharacters(serviceKey);

            let s3key = `UploadedFiles/${Module}/${screenNameClean}/${fieldName}/${fileName}`;

            const formData = new FormData();
            formData.append("file", file);

            postRequest(
                `api/vr2/uploadPDF?module=${localStorage.getItem(
                    "module",
                )}&screenName=${screenNameClean}&fieldName=${fieldName}&fileName=${fileName}`,
                formData,
            ).then((res) => {
                if (res.res.status === "success") {
                    if (dialogData?.open) {
                        handleAddRowChanges(s3key, serviceID);
                    } else {
                        changeValByserviceID(serviceID, "serviceID", "val", s3key);
                    }

                    updatedLogs[serviceID] = {
                        serviceKey: serviceKey,
                        serviceID: serviceID,
                        value: s3key,
                        DateTime,
                        scdp: childrenNode?.scdp ? "true" : "false",
                        user: userData?.USR_Email,
                    };
                    updatedVals[serviceID] = s3key;

                    dispatch(setChangesLog(updatedLogs));
                    dispatch(setStoreVals(updatedVals));
                    rerender?.();
                }
            });
            dispatch(updateValidationErrorByKey(childrenNode.serviceID, ""));
        } else if (
            files.every((file) => file.name.toLowerCase().includes("pdf")) &&
            MAX_TOTAL_SIZE <= totalSize
        ) {
            dispatch(updateValidationErrorByKey(childrenNode.serviceID, `The total size of all files must not exceed 50 MB. Currently: ${(totalSize / (1024 * 1024)).toFixed(2)} MB`));
        } else {
            dispatch(updateValidationErrorByKey(childrenNode.serviceID, "This field extension is mismatching"));
        }
    };

    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });

    const firstNode = useMemo(() => tableData?.children?.[0]?.children, [tableData]);
    const ValidationCondition_fn = useCallback(async (childrenNode, val) => {
        let getValFrom = Get_Val_By_ServiceKey(childrenNode.ValidationCondition.getValFrom, DOCJSON);

        if (childrenNode.ValidationCondition?.compartor === "<" && ((childrenNode.subtype === "date" && dayjs(val).isBefore(getValFrom)) || (childrenNode.subtype === "number" && val < getValFrom))) {
            dispatch(updateValidationErrorByKey(childrenNode.serviceID, childrenNode.ValidationCondition?.message));
        } else if (childrenNode.ValidationCondition?.compartor === ">" && (childrenNode.subtype === "date" && dayjs(val).isAfter(getValFrom)) || (childrenNode.subtype === "number" && val > getValFrom)) {
            dispatch(updateValidationErrorByKey(childrenNode.serviceID, childrenNode.ValidationCondition?.message));
        } else if (childrenNode.ValidationCondition?.compartor === "=" && (childrenNode.subtype === "date" && dayjs(val).isSame(getValFrom)) || ((childrenNode.subtype === "number" || childrenNode.subtype === "text") && val === getValFrom)) {
            dispatch(updateValidationErrorByKey(childrenNode.serviceID, childrenNode.ValidationCondition?.message));
        } else if (childrenNode.ValidationCondition?.compartor === "!=" && (childrenNode.subtype === "date" && !dayjs(val).isSame(getValFrom)) || ((childrenNode.subtype === "number" || childrenNode.subtype === "text") && val !== getValFrom)) {
            dispatch(updateValidationErrorByKey(childrenNode.serviceID, childrenNode.ValidationCondition?.message));
        }
    }, [DOCJSON, dispatch]);

    const dispatchSetDialogData = (data) => {
        if (typeof data === 'function') {
            dispatch(setDialogData(data(dialogData)));
        } else {
            dispatch(setDialogData(data));
        }
    };


    const handleAddRowChanges = useCallback((valueOrBatch, identifier) => {
        if (!dialogData || !dialogData.DialogData) return;

        let updates = {};
        if (identifier) {
            updates[identifier] = valueOrBatch;
        } else {
            updates = { ...valueOrBatch };
        }

        const visited = new Set();
        const processLookup = (val, id) => {
            const node = dialogData.DialogData?.children?.find((each) =>
                each?.serviceID === id || each?.serviceKey === id
            );

            const trackId = node?.serviceID || id;
            if (visited.has(trackId)) return;
            visited.add(trackId);

            if (node && node.onChange_operation) {
                let idParts = node.serviceID.split("#");
                idParts.splice(1, 1);
                let lookupKey = idParts.join("#");

                let ARRAY = athenaStorage[node.onChange_operation.get_From] || null;
                if (athenaStorage[lookupKey]) {
                    ARRAY = athenaStorage[lookupKey];
                }

                let matchKey =
                    (ARRAY?.length &&
                        Object.keys(ARRAY[0]).find(
                            (eachWrd) => trim(eachWrd) === trim(node.serviceKey)
                        )) ||
                    null;

                if (matchKey) {
                    let LINES = ARRAY.filter((item) => item[matchKey] === val);
                    if (LINES?.length === 1) {
                        let LINE = LINES[0];
                        Object.keys(LINE)
                            .filter((item) => item !== node.serviceKey)
                            .forEach((one) => {
                                if (updates[one] !== LINE[one]) {
                                    updates[one] = LINE[one];
                                    processLookup(LINE[one], one);
                                }
                            });
                    }
                }
            }
        };

        const initialEntries = Object.entries(updates);
        initialEntries.forEach(([id, val]) => {
            processLookup(val, id);
        });

        if (identifier) {
            dispatch(clearValidationError(identifier));
        }

        if (screenName === 'BillExtract') {
            const children = dialogData?.DialogData?.children || [];
            
            const getVal = (key) => {
                const child = children.find(c => c.serviceKey === key);
                if (!child) return null;
                if (updates.hasOwnProperty(child.serviceID)) return updates[child.serviceID];
                if (updates.hasOwnProperty(child.serviceKey)) return updates[child.serviceKey];
                return child.val;
            };

            const setUpdate = (key, val) => {
                const child = children.find(c => c.serviceKey === key);
                if (child) {
                    updates[child.serviceID] = val;
                }
            };

            const isBillingSummaryUpdate = children.some(c => 
                (updates.hasOwnProperty(c.serviceID) || updates.hasOwnProperty(c.serviceKey)) && 
                ["Qty", "Rate", "Tax Percentage", "Tax Category"].includes(c.serviceKey) &&
                c.serviceID.includes("billingsummary")
            );

            if (isBillingSummaryUpdate) {
                let taxCategory = getVal("Tax Category") || "";
                let taxPercentage = Number(getVal("Tax Percentage")) || 0;
                let qty = Number(getVal("Qty")) || 0;
                let rate = Number(getVal("Rate")) || 0;

                let baseValue = rate * qty;
                let taxValue = (taxPercentage * baseValue) / 100;
                let totalValue = baseValue + taxValue;

                setUpdate("Base Value", baseValue.toFixed(2));
                setUpdate("Tax Value", taxValue.toFixed(2));
                setUpdate("Total Value", totalValue.toFixed(2));

                let taxCode = Number.isNaN(taxPercentage) ? 0 : taxCategory + " " + String(taxPercentage) + "%";
                setUpdate("Tax Code", taxCode);

                if (taxCategory && taxCategory.includes("IGST")) {
                    setUpdate("IGST Percentage", taxPercentage.toFixed(2));
                    setUpdate("IGST", taxValue.toFixed(2));
                    setUpdate("CGST Percentage", 0);
                    setUpdate("CGST", 0);
                    setUpdate("SGST Percentage", 0);
                    setUpdate("SGST", 0);
                } else {
                    setUpdate("CGST Percentage", (taxPercentage / 2).toFixed(2));
                    setUpdate("CGST", (taxValue / 2).toFixed(2));
                    setUpdate("SGST Percentage", (taxPercentage / 2).toFixed(2));
                    setUpdate("SGST", (taxValue / 2).toFixed(2));
                    setUpdate("IGST Percentage", 0);
                    setUpdate("IGST", 0);
                }
            }
        }

        dispatchSetDialogData({
            ...dialogData,
            DialogData: {
                ...dialogData.DialogData,
                children: dialogData?.DialogData?.children?.map((each) => {
                    const idMatch = updates.hasOwnProperty(each?.serviceID);
                    const keyMatch = updates.hasOwnProperty(each?.serviceKey);
                    
                    if (idMatch || keyMatch) {
                        const newVal = idMatch ? updates[each.serviceID] : updates[each.serviceKey];
                        return { ...each, val: newVal };
                    }
                    return each;
                })
            }
        });
        rerender?.();
    }, [dialogData?.DialogData, dispatchSetDialogData, rerender]);

    useEffect(() => {
        if (dialogData?.open && dialogData?.DialogData?.children) {
            dialogData.DialogData.children.forEach((each, index) => {
                if (
                    each.render === "true" &&
                    (each.type === "select" || each.type === "search&select") &&
                    each.options?.length === 1
                ) {
                    const firstOptionValue = each.options[0].value;
                    const currentVal = String(each.val || "").trim().toLowerCase();

                    // Auto-select if value is missing, "select", or "select option"
                    if (!each.val || currentVal === "select" || currentVal === "select option") {
                        handleAddRowChanges(firstOptionValue, each.serviceID);
                        if (each.onChange_operation) {
                            onChange_operation(each, firstOptionValue, index, 'table', changeValByserviceID);
                        }
                    }
                }
            });
        }
    }, [dialogData?.open, dialogData?.DialogData, handleAddRowChanges, onChange_operation, changeValByserviceID]);

    const handleDynamicOptionFetch = async (childrenNode, rowIndex) => {
        if (
            childrenNode.dynamic_option &&
            childrenNode.dynamic_option.api_Directory
        ) {
            const key = childrenNode.serviceKey + "$" + String(rowIndex);
            if (dynamicOption_Done[key] === undefined) {
                let dependencyHash = "";
                let array = []
                if (childrenNode?.dynamic_option?.dynamic_query) {
                    childrenNode?.dynamic_option?.dynamic_query?.forEach((each) => {
                        let value = "";
                        if (each.emailid) {
                            value = userData?.USR_Email || "";
                            array.push({
                                replaceStringWith: each.replaceStringWith,
                                value: value,
                            });
                        } else {
                            value = Get_Val_By_ServiceKey(
                                each.getValueFrom,
                                DOCJSON,
                                childrenNode.serviceID.split("#")[0]
                            ) || "";
                            array.push({
                                replaceStringWith: each.replaceStringWith,
                                value: value,
                            });
                        }
                        dependencyHash += `${each.replaceStringWith}:${value}|`;
                    });
                }
                if (key && dynamicOptionDone[key] === dependencyHash) {
                    return;
                }

                if (key) {
                    dispatch(updateDynamicOptionDone({ key: key, hash: dependencyHash }));
                }
                setApiExecution((prev) => ({ ...prev, [key]: true }));
                try {
                    await fetchDynamicOptions(childrenNode, key);
                } finally {
                    setApiExecution((prev) => ({ ...prev, [key]: false }));
                }
            }
        }
    };

    useEffect(() => {
        let isMounted = true;
        const load = async () => {
            let activityCodes = await getVendorActivityCode();
            if (isMounted) {
                setAllActivityCodes(activityCodes || []);
            }
        };
        load();
        return () => {
            isMounted = false;
        };
    }, []);

    const UploadPDF = async (e, childrenNode) => {
        try {
            let serviceKey = e.target.name;
            let serviceID = e.target.id;
            let DateTime = dayjs(new Date()).format("DD-MM-YYYY HH:mm:ss");
            const files = Array.from(e?.target?.files || []);
            const totalSize = files.reduce((acc, f) => acc + f.size, 0);

            const MAX_TOTAL_SIZE = 10 * 1024 * 1024;

            let selectedFile = e?.target?.files?.[0];
            if (
                selectedFile &&
                e.target.files &&
                e.target.files?.length &&
                files.every((f) => f.name.toLowerCase().includes("pdf")) &&
                MAX_TOTAL_SIZE > totalSize
            ) {
                let fileName = generateUniqueNumber() + removeSpecialCharacters_exceptDOT(selectedFile.name);
                const module = localStorage.getItem("module");
                const fieldName = removeSpecialCharacters(serviceKey);

                let s3key = `UploadedFiles/${module}/${removeSpecialCharacters(screenName)}/${fieldName}/${fileName}`;

                const formData = new FormData();
                formData.append("file", selectedFile);

                let result = await postRequest(
                    `api/vr2/uploadPDF?action=uploadFile&module=${localStorage.getItem("module")}&screenName=${screenName}&fieldName=${fieldName}&fileName=${fileName}`,
                    formData
                );

                if (result.res.status === "success") {
                    if (dialogData?.open) {
                        handleAddRowChanges(s3key, serviceID);
                    } else {
                        changeValByserviceID(serviceID, "serviceID", "val", s3key);
                    }

                    const newLogs = {
                        ...logs,
                        [childrenNode.serviceID]: {
                            serviceKey: serviceKey,
                            serviceID: childrenNode.serviceID,
                            value: s3key,
                            DateTime,
                            scdp: childrenNode?.scdp ? "true" : "false",
                            user: userData?.USR_Email || "",
                        }
                    };
                    const newVals = { ...vals, [serviceID]: s3key };

                    dispatch(setChangesLog(newLogs));
                    dispatch(setStoreVals(newVals));
                    rerender?.();
                    setFile(prev => ({ ...prev, [serviceID]: selectedFile }));
                    dispatch(setValidationError({}));
                }
            } else if (
                files.every((f) => f.name.toLowerCase().includes("pdf")) &&
                MAX_TOTAL_SIZE <= totalSize
            ) {
                dispatch(updateValidationErrorByKey(childrenNode.serviceID, `The total size of all files must not exceed 10 MB. Currently: ${(totalSize / (1024 * 1024)).toFixed(2)} MB`));
            } else {
                dispatch(updateValidationErrorByKey(childrenNode.serviceID, "This field extension is mismatching"));
            }
            if (e && e.target) {
                e.target.value = "";
            }
        } catch (error) {
            if (e && e.target) {
                e.target.value = "";
            }
            console.error(error);
        }
    };

    const handleEditRow = () => {
        let parentObj = dialogData?.DialogData;
        let found = false;
        let NEW_DOCJSON = JSON.parse(JSON.stringify(DOCJSON));

        NEW_DOCJSON?.forEach((each) => {
            if (found) return;
            if (each.children && each.children?.length) {
                each.children.forEach((each2) => {
                    if (found) return;
                    if (each2.children && each2.children?.length) {
                        each2.children.forEach((each3, m) => {
                            if (found) return;
                            if (each3?.serviceID === parentObj?.serviceID) {
                                each2.children[m] = parentObj;
                                dispatch(setDOCJSON(NEW_DOCJSON));
                                dispatch(rerenderAction(true));
                                found = true;
                                dispatchSetDialogData({ DialogData: null, ROWNUM: 0, open: false, isEdit: false, tableId: '' });
                            }
                        });
                    }
                });
            }
        });
        if (!found) dispatchSetDialogData({ DialogData: null, ROWNUM: 0, open: false, isEdit: false, tableId: '' });
    };

    const handleEditRowClick = (rowNode, rIndex) => {
        dispatch(setDialogData({ DialogData: rowNode, ROWNUM: rIndex, open: true, isEdit: true, tableId: tableData.serviceID }));
    };

    const renderCell = useCallback((cell, ROWNUM) => {
        if (!cell) return null;

        const wrap = (content) => (
            <Tooltip title={cell.val || ""} arrow placement="top">
                <Box sx={{ display: 'inline-block' }}>{content}</Box>
            </Tooltip>
        );

        if (cell.type === "input" || cell.type === "popup_select") {

            if (cell.type === "input" && (cell.range_fn === "activation_statFus" || cell.range_fn === "activation_status")) {
                const cellSiblings = tableData?.children?.[ROWNUM]?.children || [];
                return wrap(
                    <Stack spacing={0.5} key={cell.serviceID}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Button
                                size="small"
                                variant="outlined"
                                color="secondary"
                                disabled={cell.editable === "false" || cell.val === "Waiting For Approval" || !allActivityCodes.includes(Get_Val_By_ServiceKey(null, DOCJSON, `activitycode#${cell.serviceID.split("#").pop()}`))}
                                onClick={() => {
                                    ifNotReject(cell, cellSiblings);
                                    changeValByserviceID(cell.serviceID, 'serviceID', 'val', "Waiting For Approval", false, ROWNUM);
                                }}
                                sx={{ textTransform: 'none', borderRadius: 1 }}
                            >
                                Reset
                            </Button>
                            <Button
                                size="small"
                                variant="contained"
                                color="success"
                                disabled={cell.editable === "false" || cell.val === "Approved" || cell.val === "Rejected" || !allActivityCodes.includes(Get_Val_By_ServiceKey(null, DOCJSON, `activitycode#${cell.serviceID.split("#").pop()}`))}
                                onClick={() => {
                                    ifNotReject(cell, cellSiblings);
                                    changeValByserviceID(cell.serviceID, 'serviceID', 'val', "Approved", false, ROWNUM);
                                }}
                                sx={{ textTransform: 'none', borderRadius: 1 }}
                            >
                                Approve
                            </Button>
                            <Button
                                size="small"
                                variant="contained"
                                color="error"
                                disabled={cell.editable === "false" || cell.val === "Approved" || cell.val === "Rejected" || !allActivityCodes.includes(Get_Val_By_ServiceKey(null, DOCJSON, `activitycode#${cell.serviceID.split("#").pop()}`))}
                                onClick={() => {
                                    ifReject(cell, cellSiblings);
                                    changeValByserviceID(cell.serviceID, 'serviceID', 'val', "Rejected", ROWNUM);
                                }}
                                sx={{ textTransform: 'none', borderRadius: 1 }}
                            >
                                Reject
                            </Button>
                            <TextField
                                id={cell.serviceID}
                                name={cell.serviceKey}
                                value={cell.val || ""}
                                size="small"
                                disabled
                                sx={{ width: 150, '& .MuiOutlinedInput-root': { borderRadius: 1, fontSize: '0.75rem', '&.Mui-disabled': { borderRadius: 1, overflow: 'hidden' } } }}
                            />
                        </Stack>
                        {ValidationError[cell.serviceID] && (
                            <Typography variant="caption" color="error" sx={{ fontSize: '10px' }}>{ValidationError[cell.serviceID]}</Typography>
                        )}
                    </Stack>
                );
            } else if (cell.type === "input" && cell.editable === "false") {
                return wrap(
                    <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                        {cell.val || ""}
                    </Typography>
                );
            }

            if (cell.subtype === "date") {
                return wrap(
                    <Stack spacing={0.5}>
                        <Stack direction="row" spacing={0.5} alignItems="center">
                            <DatePicker
                                format="YYYY-MM-DD"
                                disabled={cell.editable === "false"}
                                value={date_DD_MM_YYYY_TO_YYYY_MM_DD(cell.val)}
                                onChange={(date) => {
                                    const newVal = date ? date.format("DD-MM-YYYY") : '';
                                    if (newVal) {
                                        dispatch(clearValidationError(cell.serviceID));
                                    }
                                    changeValByserviceID(cell.serviceID, 'serviceID', 'val', newVal, false, ROWNUM);
                                    if (cell?.ValidationCondition) {
                                        ValidationCondition_fn(cell, newVal)
                                    }
                                    dispatch(rerenderAction(false));
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        id={cell.serviceID}
                                        sx={{ minWidth: 150, '& .MuiOutlinedInput-root': { borderRadius: 1, fontSize: '0.75rem', '&.Mui-disabled': { borderRadius: 1, overflow: 'hidden' } } }}
                                        error={!!ValidationError[cell.serviceID]}
                                        onBlur={() => {
                                            if (cell.mandatory === "true" && !cell.val) {
                                                dispatch(updateValidationErrorByKey(cell.serviceID, "This field is required"));
                                            }
                                        }}
                                    />
                                )}
                            />
                            {cell.creation_info && (
                                <Tooltip title={`create new ${cell.creation_info.transaction_name}`} arrow>
                                    <IconButton
                                        size="small"
                                        onClick={() => createTransaction(cell)}
                                        sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, p: 0.5 }}
                                    >
                                        <CirclePlus size={16} color="#2e7d32" />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Stack>
                        {ValidationError[cell.serviceID] && (
                            <Typography variant="caption" color="error" sx={{ fontSize: '10px' }}>{ValidationError[cell.serviceID]}</Typography>
                        )}
                    </Stack>
                );
            }

            if (cell.subtype === "upload") {
                return wrap(
                    <Stack direction="row" spacing={1} alignItems="center">
                        <input
                            type="file"
                            accept=".pdf"
                            className="hidden"
                            name={cell.serviceKey}
                            id={cell.serviceID}
                            ref={fileInputRef}
                            onChange={(e) => {
                                UploadPDF(e, cell);
                                if (cell?.ValidationCondition) {
                                    ValidationCondition_fn(cell, e)
                                }
                            }}
                            style={{ display: 'none' }}
                        />
                        <Button
                            disabled={cell.editable === "false"}
                            variant="outlined"
                            size="small"
                            onClick={() => fileInputRef.current?.click()}
                            startIcon={<UploadIcon size={16} />}
                            sx={{ textTransform: 'none', borderRadius: 1 }}
                        >
                            Upload
                        </Button>
                        {cell.val && (
                            <Button
                                variant="contained"
                                color="success"
                                size="small"
                                sx={{ textTransform: 'none', py: 0.5, px: 1.5, fontSize: '0.75rem', minHeight: 'unset', borderRadius: 1.5 }}
                                onClick={(e) =>
                                    openPDF(e, cell)
                                }
                            >
                                Open
                            </Button>
                        )}
                    </Stack>
                );
            }

            return wrap(<Stack spacing={0.5} key={cell.serviceID}>
                <Stack direction="row" spacing={0.5} alignItems="center">
                    <TextField
                        id={cell.serviceID}
                        value={cell.val || ""}
                        size="small"
                        disabled={cell.editable === "false" || cell.type === "popup_select"}
                        InputProps={{
                            endAdornment: apiExecution[cell.serviceKey + "$" + String(ROWNUM)] ? (
                                <CircularProgress color="inherit" size={20} />
                            ) : null,
                        }}
                        onChange={(e) => {
                            const newVal = e.target.value;
                            if (newVal) {
                                dispatch(clearValidationError(cell.serviceID));
                            }
                            changeValByserviceID(cell.serviceID, 'serviceID', 'val', newVal, false, ROWNUM);
                            if (cell?.ValidationCondition) {
                                ValidationCondition_fn(cell, newVal)
                            }
                            dispatch(rerenderAction(false));
                        }}
                        onBlur={(e) => {
                            if (cell.mandatory === "true" && !e.target.value) {
                                dispatch(updateValidationErrorByKey(cell.serviceID, "This field is required"));
                            }
                        }}
                        sx={{
                            width: cell.subtype === "number" ? 60 : 150,
                            '& .MuiOutlinedInput-root': { borderRadius: 1, fontSize: '0.75rem', '&.Mui-disabled': { borderRadius: 1, overflow: 'hidden' } }
                        }}
                    />
                    {cell.type === "popup_select" && (
                        <IconButton
                            size="small"
                            variant="outlined"
                            onClick={(e) => {
                                e.preventDefault();
                                popupSelectFn(cell, setState, state);
                                setOpenPopupSelect(ROWNUM);
                            }}
                            sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1 }}
                        >
                            <Search size={16} />
                        </IconButton>
                    )}
                    {cell.creation_info && (
                        <Tooltip title={`create new ${cell.creation_info.transaction_name}`} arrow>
                            <IconButton
                                size="small"
                                onClick={() => createTransaction(cell)}
                                sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, p: 0.5 }}
                            >
                                <CirclePlus size={16} color="#2e7d32" />
                            </IconButton>
                        </Tooltip>
                    )}
                </Stack>
                {ValidationError[cell.serviceID] && (
                    <Typography variant="caption" color="error" sx={{ fontSize: '10px' }}>{ValidationError[cell.serviceID]}</Typography>
                )}
            </Stack>);
        }

        if (cell.type === "select" || cell.type === "search&select") {
            return wrap(
                <Stack spacing={0.5}>
                    <Stack direction="row" spacing={0.5} alignItems="center">
                        <FormControl size="small" sx={{ minWidth: 200 }} error={!!ValidationError[cell.serviceID]}>
                            <Autocomplete
                                id={cell.serviceID}
                                size="small"
                                fullWidth
                                disabled={cell.editable === "false"}
                                value={
                                    (cell.options || []).find(opt => opt.value === cell.val) ||
                                    (cell.val && cell.val !== "select option" ? { label: cell.val, value: cell.val } : null)
                                }
                                options={cell.options?.filter(opt => opt.value !== '') || []}
                                getOptionLabel={(option) => typeof option === "string" ? option : (option.label || option.value || "")}
                                isOptionEqualToValue={(option, value) => option.value === value || option.value === value?.value}
                                onOpen={() => handleDynamicOptionFetch(cell, ROWNUM)}
                                onChange={(e, newValue) => {
                                    const val = newValue?.value || (typeof newValue === 'string' ? newValue : "");
                                    changeValByserviceID(cell.serviceID, 'serviceID', 'val', val, false, ROWNUM);
                                    if (val) {
                                        dispatch(clearValidationError(cell.serviceID));
                                        if (cell?.ValidationCondition) {
                                            ValidationCondition_fn(cell, val)
                                        }
                                    }
                                    dispatch(rerenderAction(false));
                                    onChange_operation(cell, val, ROWNUM, tableData.view, changeValByserviceID);
                                }}
                                onBlur={() => {
                                    if (cell.mandatory === "true" && (!cell.val || cell.val === "select option")) {
                                        dispatch(updateValidationError(cell.serviceID, "This field is required"));
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="select option"
                                        error={!!ValidationError[cell.serviceID]}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {apiExecution[cell.serviceKey + "$" + String(ROWNUM)] ? (
                                                        <Box sx={{ pr: 3, display: 'flex' }}>
                                                            <CircularProgress color="inherit" size={20} />
                                                        </Box>
                                                    ) : null}
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                        sx={{ borderRadius: 1, fontSize: '0.75rem' }}
                                    />
                                )}
                            />
                        </FormControl>
                        {cell.creation_info && (
                            <Tooltip title={`create new ${cell.creation_info.transaction_name}`} arrow>
                                <IconButton
                                    size="small"
                                    onClick={() => createTransaction(cell)}
                                    sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, p: 0.5 }}
                                >
                                    <CirclePlus size={16} color="#2e7d32" />
                                </IconButton>
                            </Tooltip>
                        )}
                        {cell.type === "search&select" &&
                            <IconButton
                                size="small"
                                onClick={() => dynamicOptionSearch(cell, dispatchSetDialogData, dialogData)}
                                sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1 }}
                            >
                                <Search size={16} />
                            </IconButton>}
                        {(cell.dynamic_option) && (
                            <Tooltip title="Refresh Dependencies" arrow>
                                <IconButton
                                    size="small"
                                    onClick={() => refreshDependencies(cell, cell.serviceKey + "$" + String(ROWNUM))}
                                    sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1 }}
                                    disabled={cell.editable === "false"}
                                >
                                    <RefreshIcon sx={{ fontSize: 16, color: 'primary.main' }} />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Stack>
                    {ValidationError[cell.serviceID] && (
                        <Typography variant="caption" color="error" sx={{ fontSize: '10px' }}>{ValidationError[cell.serviceID]}</Typography>
                    )}
                </Stack>
            );
        }

        return wrap(
            <Typography variant="body2" sx={{ fontSize: '0.75rem', px: 1, py: 0.5 }}>
                {cell.val || ""}
            </Typography>
        );
    }, [changeValByserviceID, dispatch, ValidationError, ValidationCondition_fn, UploadPDF, tableData, popupSelectFn, state, dynamicOptionSearch, dialogData, onChange_operation, fileInputRef, ifNotReject, ifReject]);

    if (!firstNode) return null;

    const headers = firstNode?.filter((childrenNode) => childrenNode.render !== "false") || [];
    const tableGroup = firstNode?.filter((childrenNode) => childrenNode.render !== "false") || [];


    const on_popup_table_search = (e) => {
        const VAL = e.target.value;
        const data = state.popup_table.data;
        const filteredData = data.filter((row) =>
            Object.values(row).some(
                (value) =>
                    value &&
                    value
                        .toString()
                        .replace(/\s/g, "")
                        .toLowerCase()
                        .includes(VAL.replace(/\s/g, "").toLowerCase()),
            ),
        );

        setState({
            ...state,
            popup_table: {
                ...state.popup_table,
                search: VAL,
                filteredData: filteredData || [],
            },
        });
    };

    return (
        <> {
            askReason && (
                <Popup
                    noClose={true}
                    zIndex={3000}
                    content={
                        <Stack spacing={2} sx={{ minWidth: 400 }}>
                            <Typography variant="h6" sx={{ fontSize: '1rem' }}>
                                {askReason.title} for Rejection: {askReason.mandatory === "true" && <Box component="span" sx={{ color: 'error.main' }}>*</Box>}
                            </Typography>
                            <TextField
                                multiline
                                minRows={3}
                                size="small"
                                id={askReason.serviceID}
                                name={askReason.serviceKey}
                                value={askReason.val || ""}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    setAskReason(prev => ({ ...prev, val }));
                                    changeValByserviceID(askReason.serviceID, 'serviceID', 'val', val);
                                }}
                                onBlur={() => {
                                    if (askReason.mandatory === "true" && !askReason.val) {
                                        dispatch(updateValidationError(askReason.serviceID, "This field is required"));
                                    } else {
                                        dispatch(clearValidationError(askReason.serviceID));
                                    }
                                }}
                                error={!!ValidationError[askReason.serviceID]}
                                helperText={ValidationError[askReason.serviceID]}
                            />
                            <Stack direction="row" spacing={2} justifyContent="flex-end">
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    onClick={() => {
                                        changeValByserviceID(askReason.targetCell.serviceID, 'serviceID', 'val', "Waiting For Approval");
                                        setAskReason(null);
                                    }}
                                    sx={{ textTransform: 'none' }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    color="success"
                                    disabled={!askReason.val}
                                    onClick={() => {
                                        setAskReason(null);
                                    }}
                                    sx={{ textTransform: 'none' }}
                                >
                                    Submit
                                </Button>
                            </Stack>
                        </Stack>
                    }
                />
            )}
            {state.popData_PDF &&
                state.showPopUP_PDF && (
                    <Popup
                        content={
                            <>
                                <iframe
                                    src={
                                        state.fileType.toLowerCase() ===
                                            "pdf"
                                            ? `data:application/pdf;base64,${state.popData_PDF}`
                                            : `data:image/${state.fileType};base64,${state.popData_PDF}`
                                    }
                                    title="pdf-viewer"
                                    style={{
                                        width: "100%",
                                        height: "500px",
                                    }}
                                />
                            </>
                        }
                        handleClose={() =>
                            setState(prev => ({ ...prev, showPopUP_PDF: null }))
                        }
                    />
                )}

            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DialogBox title="Transaction Search" open={state?.open_popup} setOpen={() => setState(prev => ({ ...prev, open_popup: false }))}>
                    <TableWithFilter openPopupSelect={openPopupSelect} setOpenPopupSelect={setOpenPopupSelect} tableData={state?.popup_table} onChange={on_popup_table_search} handleAddRowChanges={handleAddRowChanges} setState={() => setState(prev => ({ ...prev, open_popup: false }))} state={state} DialogData={dialogData} />
                </DialogBox>
                <DraggableDialog id="AddRow-1" title={dialogData?.isEdit ? "Edit Row" : "Add Row"} open={dialogData?.open && tableData.serviceID.includes(dialogData?.tableId)} onOpenChange={(open) => !open && dispatchSetDialogData({ DialogData: null, open: false, ROWNUM: '', isEdit: false, tableId: '' })} width="80vw" height="90vh">
                    <Box sx={{ p: 2 }}>
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                dialogData?.isEdit
                                    ? handleEditRow()
                                    : tableRowAdd(
                                        null,
                                        dialogData?.DialogData,
                                        null,
                                        dispatchSetDialogData,
                                        true,
                                        tableData.serviceID
                                    );
                            }}
                            id="AddRow-form"
                        >
                            <Grid container spacing={2}>
                                {dialogData?.DialogData?.children?.map((each, index) => {
                                    if (each?.render === "true" && each?.serviceKey !== "Line ID") {
                                        return (
                                            <Grid item xs={12} sm={6} md={3} key={each.serviceID || index}>
                                                <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                                                    {each.serviceKey}
                                                    {each.mandatory === 'true' && <Box component="span" sx={{ color: 'error.main', ml: 0.5 }}>*</Box>}
                                                </Typography>
                                                {each.subtype === "date" ? (
                                                    <Stack spacing={0.5}>
                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                            <DatePicker
                                                                format="YYYY-MM-DD"
                                                                disabled={each.editable === "false"}
                                                                value={date_DD_MM_YYYY_TO_YYYY_MM_DD(each.val)}
                                                                onChange={(date) => {
                                                                    const newVal = date ? date.format("DD-MM-YYYY") : '';
                                                                    handleAddRowChanges(newVal, each.serviceID);
                                                                    if (each?.ValidationCondition) {
                                                                        ValidationCondition_fn(each, newVal)
                                                                    }
                                                                }}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        fullWidth
                                                                        size="small"
                                                                        id={each.serviceID}
                                                                        error={!!ValidationError[each.serviceID]}
                                                                        onBlur={() => {
                                                                            if (each.mandatory === "true" && !each.val) {
                                                                                dispatch(updateValidationError(each.serviceID, "This field is required"));
                                                                            }
                                                                        }}
                                                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, '&.Mui-disabled': { borderRadius: 1.5, overflow: 'hidden' } } }}
                                                                    />
                                                                )}
                                                            />
                                                            {each.creation_info && (
                                                                <Tooltip title={`create new ${each.creation_info.transaction_name}`} arrow>
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={() => createTransaction(each)}
                                                                        sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1.5, p: 0.5 }}
                                                                    >
                                                                        <CirclePlus size={18} color="#2e7d32" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}
                                                        </Stack>
                                                        {ValidationError[each.serviceID] && (
                                                            <Typography variant="caption" color="error">{ValidationError[each.serviceID]}</Typography>
                                                        )}
                                                    </Stack>
                                                ) : each.options ||
                                                    each.type === "search&select" ||
                                                    each.type === "select" ||
                                                    each.type === "multiselect" ? (
                                                    <Stack spacing={0.5} sx={{ width: '100%' }}>
                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                            <FormControl fullWidth size="small" error={!!ValidationError[each.serviceID]}>
                                                                <Autocomplete
                                                                    id={each.serviceID}
                                                                    size="small"
                                                                    fullWidth
                                                                    disabled={each.editable === "false"}
                                                                    value={
                                                                        (each.options || []).find(opt => opt.value === each.val) ||
                                                                        (each.val ? { label: each.val, value: each.val } : null)
                                                                    }
                                                                    options={each.options?.filter(opt => opt.value !== '') || []}
                                                                    getOptionLabel={(option) => typeof option === "string" ? option : (option.label || option.value || "")}
                                                                    isOptionEqualToValue={(option, value) => option.value === value || option.value === value?.value}
                                                                    onOpen={() => handleDynamicOptionFetch(each, index)}
                                                                    onChange={(e, newValue) => {
                                                                        const val = newValue?.value || newValue || "select";
                                                                        handleAddRowChanges(val, each.serviceID)
                                                                        if (val && val !== "select") {
                                                                            if (each.onChange_operation) {
                                                                                onChange_operation(each, val, index, 'table', changeValByserviceID);
                                                                            }
                                                                        }
                                                                    }}
                                                                    onBlur={() => {
                                                                        if (each.mandatory === "true" && (!each.val || each.val === "select")) {
                                                                            dispatch(updateValidationError(each.serviceID, "This field is required"));
                                                                        }
                                                                    }}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            error={!!ValidationError[each.serviceID]}
                                                                            InputProps={{
                                                                                ...params.InputProps,
                                                                                endAdornment: (
                                                                                    <React.Fragment>
                                                                                        {apiExecution[each.serviceKey + "$" + String(index)] ? (
                                                                                            <Box sx={{ pr: 3, display: 'flex' }}>
                                                                                                <CircularProgress color="inherit" size={20} />
                                                                                            </Box>
                                                                                        ) : null}
                                                                                        {params.InputProps.endAdornment}
                                                                                    </React.Fragment>
                                                                                ),
                                                                            }}
                                                                            sx={{ borderRadius: 1.5 }}
                                                                        />
                                                                    )}
                                                                />
                                                            </FormControl>

                                                            {each.type === "search&select" && (
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        dynamicOptionSearch(each, dispatchSetDialogData, dialogData);
                                                                    }}
                                                                    sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1.5, p: 0.5 }}
                                                                >
                                                                    <Search size={18} />
                                                                </IconButton>
                                                            )}
                                                            {each.creation_info && (
                                                                <Tooltip title={`create new ${each.creation_info.transaction_name}`} arrow>
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={() => createTransaction(each)}
                                                                        sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1.5, p: 0.5 }}
                                                                    >
                                                                        <CirclePlus size={18} color="#2e7d32" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}
                                                            {(each.dynamic_option) && (
                                                                <Tooltip title="Refresh Dependencies" arrow>
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={() => refreshDependencies(each, each.serviceKey + "$" + String(dialogData?.ROWNUM))}
                                                                        sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1.5, p: 0.5 }}
                                                                        disabled={each.editable === "false"}
                                                                    >
                                                                        <RefreshIcon sx={{ fontSize: 18, color: 'primary.main' }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}
                                                        </Stack>
                                                        {ValidationError[each.serviceID] && (
                                                            <Typography variant="caption" color="error">{ValidationError[each.serviceID]}</Typography>
                                                        )}
                                                    </Stack>
                                                ) : each.type === "input" &&
                                                    (each.subtype === "text" || each.subtype === 'number') ? <TextField
                                                    fullWidth
                                                    id={each.serviceID}
                                                    name={each.serviceKey}
                                                    size="small"
                                                    disabled={each.editable === "false"}
                                                    value={each.val || ""}
                                                    InputProps={{
                                                        endAdornment: apiExecution[each.serviceKey + "$" + String(index)] ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                        ) : null,
                                                    }}
                                                    onChange={(e) => handleAddRowChanges(e.target.value, each.serviceID)}
                                                    onBlur={(e) => {
                                                        if (each.mandatory === "true" && !e.target.value) {
                                                            dispatch(updateValidationError(each.serviceID, "This field is required"));
                                                        }
                                                    }}
                                                    error={!!ValidationError[each.serviceID]}
                                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, '&.Mui-disabled': { borderRadius: 1.5, overflow: 'hidden' } } }}
                                                /> : each.children === undefined &&
                                                    each.type === "input" &&
                                                    each.subtype.includes("upload") ? (
                                                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }}>
                                                        <input
                                                            type="file"
                                                            accept=".pdf"
                                                            className="hidden"
                                                            name={each.serviceKey}
                                                            id={each.serviceID}
                                                            ref={fileInputRef}
                                                            onChange={(e) => {
                                                                UploadPDF(e, each);
                                                                if (each?.ValidationCondition) {
                                                                    ValidationCondition_fn(each, e)
                                                                }
                                                            }}
                                                            style={{ display: 'none' }}
                                                        />
                                                        <Button
                                                            disabled={each.editable === "false"}
                                                            variant="outlined"
                                                            size="small"
                                                            onClick={() => fileInputRef.current?.click()}
                                                            startIcon={<UploadIcon size={16} />}
                                                            sx={{ textTransform: 'none', borderRadius: 1 }}
                                                        >
                                                            Upload
                                                        </Button>
                                                        {each.val && (
                                                            <Button
                                                                variant="contained"
                                                                color="success"
                                                                size="small"
                                                                sx={{ textTransform: 'none', py: 0.5, px: 1.5, fontSize: '0.75rem', minHeight: 'unset', borderRadius: 1.5 }}
                                                                onClick={(e) =>
                                                                    openPDF(e, each)
                                                                }
                                                            >
                                                                Open
                                                            </Button>
                                                        )}

                                                        {ValidationError[
                                                            `${each.serviceID}`
                                                        ] && (
                                                                <Typography
                                                                    variant="caption"
                                                                    color="error"
                                                                    sx={{ ml: 1 }}
                                                                >
                                                                    {
                                                                        ValidationError[
                                                                        `${each.serviceID}`
                                                                        ]
                                                                    }
                                                                </Typography>
                                                            )}

                                                        {each.val &&
                                                            state.popData_PDF &&
                                                            state.showPopUP_PDF &&
                                                            state.showPopUP_PDF ===
                                                            each.serviceID ? (
                                                            <Popup
                                                                content={
                                                                    <>
                                                                        <iframe
                                                                            src={
                                                                                state.popData_PDF?.startsWith('JVBERi') || state.fileType?.toLowerCase()?.endsWith("pdf")
                                                                                    ? `data:application/pdf;base64,${state.popData_PDF}`
                                                                                    : `data:image/${state.fileType || 'jpeg'};base64,${state.popData_PDF}`
                                                                            }
                                                                            title="pdf-viewer"
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "500px",
                                                                            }}
                                                                        />
                                                                    </>
                                                                }
                                                                handleClose={() =>
                                                                    setState(prev => ({ ...prev, showPopUP_PDF: null }))
                                                                }
                                                            />
                                                        ) : null}
                                                    </Stack>
                                                ) : (
                                                    <Stack spacing={0.5} sx={{ width: '100%' }}>
                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                            <TextField
                                                                fullWidth
                                                                id={each.serviceID}
                                                                name={each.serviceKey}
                                                                size="small"
                                                                disabled={each.editable === "false" || each.type === "popup_select"}
                                                                value={each.val || ""}
                                                                onChange={(e) => handleAddRowChanges(e.target.value, each.serviceID)}
                                                                onBlur={(e) => {
                                                                    if (each.mandatory === "true" && !e.target.value) {
                                                                        dispatch(updateValidationError(each.serviceID, "This field is required"));
                                                                    }
                                                                }}
                                                                error={!!ValidationError[each.serviceID]}
                                                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, '&.Mui-disabled': { borderRadius: 1.5, overflow: 'hidden' } } }}
                                                            />
                                                            {each.type === "popup_select" && (
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        popupSelectFn(each, setState, state);
                                                                        setOpenPopupSelect(dialogData?.ROWNUM);
                                                                    }}
                                                                    sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1.5, p: 0.5 }}
                                                                >
                                                                    <Search size={18} />
                                                                </IconButton>
                                                            )}
                                                            {each.creation_info && (
                                                                <Tooltip title={`create new ${each.creation_info.transaction_name}`} arrow>
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={() => createTransaction(each)}
                                                                        sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1.5, p: 0.5 }}
                                                                    >
                                                                        <CirclePlus size={18} color="#2e7d32" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}
                                                        </Stack>
                                                        {ValidationError[each.serviceID] && (
                                                            <Typography variant="caption" color="error">{ValidationError[each.serviceID]}</Typography>
                                                        )}
                                                    </Stack>
                                                )}
                                            </Grid>
                                        );
                                    }
                                    return null;
                                })}
                            </Grid>
                            {dialogData?.DialogData?.children?.some((child) => child.render === "true" && child.editable === "true") &&
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    mt: 3,
                                    gap: 2,
                                    position: 'sticky',
                                    bottom: 0, // Offset the padding of the outer Box (p: 2 = 16px)
                                    bgcolor: 'background.paper',
                                    pt: 2,
                                    pb: 1, // Add some space from the bottom edge
                                    borderTop: '1px solid',
                                    borderColor: 'divider',
                                    zIndex: 10,
                                    mx: -2, // Pull to edges of the dialog box (offsetting p:2)
                                    px: 2   // Re-add horizontal padding for content alignment
                                }}>
                                    <Button
                                        variant="contained"
                                        color="success"
                                        type="submit"
                                        startIcon={<BookUp size={18} />}
                                        sx={{ borderRadius: 1.5, textTransform: 'none' }}
                                    >
                                        Submit
                                    </Button>
                                </Box>
                            }
                        </form>
                    </Box>
                </DraggableDialog>

                <Box>
                    {isBodySection ? (
                        <Accordion
                            defaultExpanded
                            sx={{
                                mb: 2,
                                boxShadow: 'none',
                                border: '1px solid',
                                borderColor: 'divider',
                                borderRadius: '8px !important',
                                overflow: 'hidden',
                                '&:before': { display: 'none' },
                                bgcolor: 'background.paper',
                                '&.Mui-expanded': {
                                    borderLeft: '4px solid',
                                    borderLeftColor: 'primary.main',
                                }
                            }}
                        >
                            <AccordionSummary
                                expandIcon={<ChevronDown size={20} />}
                                sx={{
                                    bgcolor: '#ffffff',
                                    borderBottom: '1px solid',
                                    borderColor: 'divider',
                                    minHeight: 36,
                                    '&.Mui-expanded': {
                                        minHeight: 36,
                                        bgcolor: '#ffffff'
                                    },
                                    '& .MuiAccordionSummary-content': {
                                        my: 0.5,
                                        alignItems: 'center'
                                    }
                                }}
                            >
                                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%', pr: 2 }}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600, fontSize: '0.85rem' }}>
                                        {tableData.title}
                                    </Typography>
                                    <Stack direction="row" spacing={1} onClick={(e) => e.stopPropagation()}>
                                        <IconButton size="small" sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1.5 }}>
                                            <DownloadIcon size={18} />
                                        </IconButton>
                                    </Stack>
                                </Stack>
                            </AccordionSummary>
                            <AccordionDetails sx={{ p: 0 }}>
                                <TableContainer component={Paper} sx={{ borderRadius: 0, border: 'none', overflowX: 'auto', maxHeight: '65vh' }}>
                                    <Table size="small" stickyHeader>
                                        <TableHead>
                                            <TableRow sx={{ bgcolor: '#ffffff' }}>
                                                {headers.map((childrenNode) => {
                                                    const isActivityCodeCol = childrenNode.serviceID?.toLowerCase().includes("activitycode") || childrenNode.serviceKey?.toLowerCase().includes("activitycode");
                                                    let showInvalidAsterisk = false;
                                                    if (isActivityCodeCol && tableData?.children) {
                                                        showInvalidAsterisk = tableData.children.some((rowNode) => {
                                                            const firstCell = rowNode?.children?.[0];
                                                            if (firstCell) {
                                                                const rowId = firstCell.serviceID?.split("#").pop();
                                                                if (rowId) {
                                                                    const val = Get_Val_By_ServiceKey(null, DOCJSON, `activitycode#${rowId}`);
                                                                    return val && !allActivityCodes.includes(val);
                                                                }
                                                            }
                                                            return false;
                                                        });
                                                    }

                                                    return (
                                                        <TableCell
                                                            key={childrenNode.serviceKey}
                                                            sx={{
                                                                fontWeight: 600,
                                                                color: 'primary.main',
                                                                minWidth: childrenNode.css?.maxWidth || childrenNode.css?.width || 120,
                                                                bgcolor: 'background.paper',
                                                                zIndex: 10,
                                                                py: 1,
                                                                fontSize: '0.8rem'
                                                            }}
                                                        >
                                                            {childrenNode.title}
                                                            {childrenNode.mandatory === "true" && <Box component="span" sx={{ color: 'error.main', ml: 0.5 }}>*</Box>}
                                                            {showInvalidAsterisk && <Box component="span" sx={{ color: 'error.main', ml: 0.5 }} title="Contains invalid activity code">*</Box>}
                                                        </TableCell>
                                                    )
                                                })}
                                                <TableCell
                                                    sx={{
                                                        fontWeight: 600,
                                                        color: 'primary.main',
                                                        width: 120,
                                                        position: 'sticky',
                                                        right: 0,
                                                        bgcolor: 'background.paper',
                                                        zIndex: 10,
                                                        borderLeft: '1px solid',
                                                        borderColor: 'divider'
                                                    }}
                                                >
                                                    Action
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {tableData.children?.map((rowNode, rIndex) => (
                                                <TableRow key={rIndex} hover>
                                                    {rowNode?.children?.map((childrenNode) => {
                                                        if (childrenNode.render === "true") {
                                                            return (
                                                                <TableCell key={childrenNode.serviceID || childrenNode.serviceKey} sx={{ padding: '8px 16px !important' }}>
                                                                    {renderCell(childrenNode, rIndex)}
                                                                </TableCell>
                                                            )
                                                        }
                                                        return null;
                                                    })}
                                                    <TableCell
                                                        sx={{
                                                            padding: '4px 8px !important',
                                                            position: 'sticky',
                                                            right: 0,
                                                            bgcolor: 'background.paper',
                                                            zIndex: 1,
                                                            borderLeft: '1px solid',
                                                            borderColor: 'divider'
                                                        }}
                                                    >
                                                        <Stack direction="row" spacing={1}>
                                                            <IconButton
                                                                size="small"
                                                                color="primary"
                                                                onClick={() => handleEditRowClick(rowNode, rIndex)}
                                                            >
                                                                <SquareMenu size={18} />
                                                            </IconButton>
                                                            {tableGroup.some((child) => child.render === "true" && child.editable === "true") &&
                                                                <IconButton
                                                                    size="small"
                                                                    color="error"
                                                                    onClick={() => tableDelRow(rowNode.serviceID)}
                                                                    disabled={typeof rowNode?.serviceKey === 'string' && rowNode.serviceKey.endsWith("#0001")}
                                                                >
                                                                    <Delete size={18} />
                                                                </IconButton>}
                                                            {tableGroup.some((child) => child.render === "true" && child.editable === "true") &&
                                                                <IconButton
                                                                    size="small"
                                                                    color="primary"
                                                                    onClick={() => tableCopyRow(rowNode.children, rowNode)}
                                                                >
                                                                    <CopyIcon size={18} />
                                                                </IconButton>}
                                                        </Stack>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                            {tableData.AddRow === "true" &&
                                                <TableRow>
                                                    <TableCell colSpan={headers.length + 1} sx={{ p: 1 }}>
                                                        <Stack direction="row" spacing={1}>
                                                            <IconButton
                                                                size="small"
                                                                color="error"
                                                                onClick={() => tableDelRow(tableData.children[tableData.children.length - 1].serviceID)}
                                                                disabled={tableData?.children?.length === 1 || (typeof tableData.children?.[tableData.children.length - 1]?.serviceKey === 'string' && tableData.children[tableData.children.length - 1].serviceKey.endsWith("#0001"))}
                                                            >
                                                                <CircleDivide size={20} />
                                                            </IconButton>
                                                            <IconButton
                                                                size="small"
                                                                color="primary"
                                                                disabled={!tableData.children?.[tableData.children.length - 1]?.children}
                                                                onClick={() => tableRowAdd(tableData.children[tableData.children.length - 1].children, tableData.children[tableData.children.length - 1], tableData.children.length, dispatchSetDialogData, false, tableData.serviceID)}
                                                            >
                                                                <CirclePlus size={20} />
                                                            </IconButton>
                                                        </Stack>
                                                    </TableCell>
                                                </TableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </AccordionDetails>
                        </Accordion>
                    ) : (
                        <TableContainer component={Paper} sx={{ borderRadius: 0, border: 'none', overflowX: 'auto', maxHeight: '100%' }}>
                            <Table size="small" stickyHeader>
                                <TableHead>
                                    <TableRow sx={{ bgcolor: '#ffffff' }}>
                                        {headers.map((childrenNode) => (
                                            <TableCell
                                                key={childrenNode.serviceKey}
                                                sx={{
                                                    fontWeight: 600,
                                                    color: 'primary.main',
                                                    minWidth: childrenNode.css?.maxWidth || childrenNode.css?.width || 120,
                                                    bgcolor: 'background.paper',
                                                    zIndex: 10,
                                                    py: 1,
                                                    fontSize: '0.8rem'
                                                }}
                                            >
                                                {childrenNode.title}
                                                {childrenNode.mandatory === "true" && <Box component="span" sx={{ color: 'error.main', ml: 0.5 }}>*</Box>}
                                            </TableCell>
                                        ))}
                                        <TableCell
                                            sx={{
                                                fontWeight: 600,
                                                color: 'primary.main',
                                                width: 120,
                                                position: 'sticky',
                                                right: 0,
                                                bgcolor: 'background.paper',
                                                zIndex: 10,
                                                borderLeft: '1px solid',
                                                borderColor: 'divider'
                                            }}
                                        >
                                            Action
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tableData.children?.map((rowNode, rIndex) => (
                                        <TableRow key={rIndex} hover>
                                            {rowNode?.children?.map((childrenNode) => {
                                                if (childrenNode.render === "true") {
                                                    return (
                                                        <TableCell key={childrenNode.serviceID || childrenNode.serviceKey} sx={{ padding: '4px 8px !important' }}>
                                                            {renderCell(childrenNode, rIndex)}
                                                        </TableCell>
                                                    )
                                                }
                                                return null;
                                            })}
                                            <TableCell
                                                sx={{
                                                    padding: '4px 8px !important',
                                                    position: 'sticky',
                                                    right: 0,
                                                    bgcolor: 'background.paper',
                                                    zIndex: 1,
                                                    borderLeft: '1px solid',
                                                    borderColor: 'divider'
                                                }}
                                            >
                                                <Stack direction="row" spacing={1}>
                                                    <IconButton
                                                        size="small"
                                                        color="primary"
                                                        onClick={() => handleEditRowClick(rowNode, rIndex)}
                                                    >
                                                        <SquareMenu size={18} />
                                                    </IconButton>
                                                    {(tableGroup.some((child) => child.render === "true" && child.editable === "true") && isBodySection) &&
                                                        <IconButton
                                                            size="small"
                                                            color="error"
                                                            onClick={() => tableDelRow(rowNode.serviceID)}
                                                            disabled={typeof rowNode?.serviceKey === 'string' && rowNode.serviceKey.endsWith("#0001")}
                                                        >
                                                            <Delete size={18} />
                                                        </IconButton>}
                                                    {(tableGroup.some((child) => child.render === "true" && child.editable === "true") && isBodySection) &&
                                                        <IconButton
                                                            size="small"
                                                            color="primary"
                                                            onClick={() => tableCopyRow(rowNode.children, rowNode)}
                                                        >
                                                            <CopyIcon size={18} />
                                                        </IconButton>}
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    {tableData.AddRow === "true" &&
                                        <TableRow>
                                            <TableCell colSpan={headers.length + 1} sx={{ p: 1 }}>
                                                <Stack direction="row" spacing={1}>
                                                    <IconButton
                                                        size="small"
                                                        color="error"
                                                        onClick={() => tableDelRow(tableData.children[tableData.children.length - 1].serviceID)}
                                                        disabled={tableData?.children?.length === 1 || (typeof tableData.children?.[tableData.children.length - 1]?.serviceKey === 'string' && tableData.children[tableData.children.length - 1].serviceKey.endsWith("#0001"))}
                                                    >
                                                        <CircleDivide size={20} />
                                                    </IconButton>
                                                    <IconButton
                                                        size="small"
                                                        color="primary"
                                                        disabled={!tableData.children?.[tableData.children.length - 1]?.children}
                                                        onClick={() => tableRowAdd(tableData.children[tableData.children.length - 1].children, tableData.children[tableData.children.length - 1], tableData.children.length, dispatchSetDialogData, false, tableData.serviceID)}
                                                    >
                                                        <CirclePlus size={20} />
                                                    </IconButton>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </Box>
            </LocalizationProvider>
        </>)
}